/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './political-campaign-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {formatAdnStat} from '../common/filters/format-adn-stat';
import {AppLocaleService} from '../common/locale/app-locale.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-political-campaign-list-page',
  template
})
export class PoliticalCampaignListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.pol.political-campaigns.political-campaign';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'politicalEntity', labelInstant: 'Political Entity', sortable: false},
    {param: 'election', sortable: false},
    {param: 'totalBudget', labelInstant: 'Total Budget', sortable: false},
    {param: 'ownerTeam', labelInstant: 'Owner team', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService
  ) {
    super(LocalNetworkProfile);
  }

  refLabel(value: any): string {
    return (value && value.name) || value || '';
  }

  formatStat(value: any): string {
    return formatAdnStat(value, undefined, undefined, undefined, this.LocalNetworkProfile.get('defaultCurrency'), this.appLocale.getLocaleId());
  }
}
